/**
 * @file EmojiExtension.js
 * @description Lightweight TipTap extension replacing @tiptap-pro/extension-emoji.
 * Emojis are inserted as plain Unicode characters via emoji-picker-react, so no
 * special node schema or Pro registry access is required.
 */

import { Extension } from '@tiptap/core';

const Emoji = Extension.create({
    name: 'emoji',
});

export default Emoji;
